import { reportError } from '@pypestream/utils';

import { ErrorFlags, ErrorTags } from './types';

interface TaggedState {
  hasTag: (tag: string) => boolean;
}

/**
 * Reads the boundary's flags out of a set of machine states.
 *
 * Takes the states as an argument instead of calling the app's XState hook, so
 * the rule is one implementation and is testable without a running machine.
 */
export const resolveErrorFlags = (states: TaggedState[]): ErrorFlags => ({
  isLocalError: states.some((state) => state.hasTag(ErrorTags.local)),
  isXstateError: states.some((state) => state.hasTag(ErrorTags.xstate)),
  isGlobalError: states.some((state) => state.hasTag(ErrorTags.global)),
});

/**
 * Logs a render-phase crash and reports which React subtree it happened in.
 *
 * Manager has reported the component stack since before the two copies
 * diverged; pro-studio did not. Sharing the boundary makes it true for both.
 */
export const logError = (
  error: Error,
  info: { componentStack?: string | null }
) => {
  console.log(
    '%cERROR!>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',
    'color: red; font-size: larger; font-weight: bold',
    error,
    info?.componentStack
  );

  reportError(error, {
    source: 'ErrorBoundary.onError',
    extra: { componentStack: info?.componentStack },
  });
};
